
import React from 'react';
import { loadDynamoItems } from "../actions";
import { DashboardContainer } from "../../../funcs/utils";

const Record = (props) => {

  const container_style = {
    display: "flex",
    fontFamily: "consolas",
  };

  const pre_style = {
    color: "black",
    paddingBottom: "1rem",
    overflowX: "auto",
  }


  const item_gen = (item) => {
    const tile_style = {
      flex: "1 0",
    };

    if (!item) {
      return (<div style={tile_style}/>);
    }
    const label_style = {
      fontSize: "2rem",
      fontWeight: "bold",
    }
    return (
      <div style={tile_style}>
        <div>
          <div align={"center"}>
            <span style={label_style}>{item.label}</span>
          </div>
          <pre style={pre_style}>
            {JSON.stringify(item.item, null, 2)}
          </pre>
        </div>
      </div>
    )
  };

  const rows = [];
  const space = (<div style={{flex: "0 0 2rem"}}/>);

  for(let i=0; i < props.items.length; i += 2) {
    if (i === props.items.length - 1) {
      // last item
      rows.push((
        <div style={container_style} key={i}>
          { item_gen(props.items[i]) }
          { space }
          { item_gen(null) }
        </div>
      ))
    } else {
      // next two items
      rows.push((
        <div style={container_style} key={i}>
          { item_gen(props.items[i]) }
          { space }
          { item_gen(props.items[i+1]) }
        </div>
      ))
    }
  }
  return (
    <DashboardContainer
      client={props.client}
      title={props.title}>
      { rows }
    </DashboardContainer>
  );
};

class DynamoDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      email_metadata: null,
      tda: [],
      dwolla: [],
      dwolla_payment: [],
      onboarding: [],
      metadata: [],
      accts: [],
      loading: false,
    }

  }

  componentDidMount = () => {
    this.doLoad();
  }

  doLoad = () => {
    this.setState({ loading: true });
    loadDynamoItems(this.props.token, this.props.username)
      .then(results => {
        this.setState(results);
      })
  }

  render = () => {

    const item_props = ["user", "email_metadata"];
    const items_props = [
      "tda", "dwolla", "dwolla_payment", "onboarding", "metadata", "accts"];
    return (
      <div className="img-col">
        <div className="container">
          { item_props.map(prop => (
            <Record
              key={prop}
              title={prop}
              client={this.props.client}
              items={[this.state[prop]]}/>)) }

          { items_props.map(prop => (
            <Record
              key={prop}
              title={prop}
              client={this.props.client}
              items={this.state[prop]}/>)) }

        </div>
      </div>
    )
  }
}

export { DynamoDashboard };
